import chat from './chat.js';
import publisher from './user.js';
import support from './support.js';

export default {
    chat: chat,
    support: support,
    publisher: publisher,
}